export default {
    brand: '매일국어T',

    // 기본 버튼들
    buttons: {
        addAllStar: '전체 별주기',
        confirm: '확인',
        cancel: '취소',
        close: '닫기',
        next: '다음',
        previous: '이전',
        start: '시작하기',
        continue: '계속하기',
        stop: '중단하기',
        exit: '나가기',
        save: '저장',
        delete: '삭제',
        edit: '수정',
        submit: '제출',
        reset: '초기화',
        selectAll: '전체 선택',
        end: '종료',
        assign: '지정',
        auth: {
            login: '로그인',
            logout: '로그아웃',
        },
    },

    // 공통 레이블
    labels: {
        module: '활동',
        lesson: '활동꾸러미',
        star: '칭찬별',
        waitingRoom: '대기실',
        taskPage: '과제 목록',
        screen: '칠판 화면',
        classroom: '교실',
        student: '학생',
        teacher: '선생님',
        grade: '학년',
        school: '학교',
        name: '이름',
        date: '날짜',
        time: '시간',
        duration: '시간',
        count: '개수',
        result: '결과',
        status: '상태',
        mode: '모드',
        type: '유형',
        level: '레벨',
        score: '점수',
        question: '문제',
        answer: '답',
        online: '온라인',
        offline: '오프라인',
        list: '목록',
    },

    // 헤더 타이틀
    headerTitle: {
        waitingRoom: '대기실',
    },

    // 공통 메시지
    messages: {
        confirm: '정말로 {action}하시겠습니까?',
        success: '{action}이 완료되었습니다.',
        error: '오류가 발생했습니다.',
        networkError: '네트워크 오류가 발생했습니다.',
        loading: '로딩 중...',
        noData: '데이터가 없습니다.',
        selectOption: '옵션을 선택해주세요.',
    },

    // 상태
    status: {
        inProgress: '진행 중',
        completed: '완료',
        pending: '대기 중',
        failed: '실패',
        locked: '잠금',
        unlocked: '해제',
    },

    // 교과 관련
    subject: {
        textbook: '교과서',
        korean: '국어',
        koreanActivity: '국어활동',
        math: '수학',
        science: '과학',
        socialStudies: '사회',
        english: '영어',
    },

    // 화면/페이지 관련
    screen: {
        basic: '기본 화면',
        waitingRoom: '대기실',
        activity: '활동 화면',
        sessionResult: '수업 결과 화면',
        moduleResult: '활동 결과 화면',
    },

    // 시스템 메시지
    system: {
        networkError: {
            title: '인터넷 접속이 원활하지 않아요.',
            message: '잠시만 기다려주세요...',
            refresh: '새로고침',
        },
        windowError: {
            closeManually: '오류가 발생했습니다. 창을 직접 닫아주세요.',
        },
        audio: {
            playError: '오디오 재생중 문제가 생겼습니다.',
        },
    },

    // 접근성 (alt, title 등)
    accessibility: {
        alt: {
            starDraw: '별뽑기',
            seedLetter: '씨앗글자',
            recentSessionResult: '최근 수업 결과',
            questionImage: '문제 이미지',
            explanationImage: '해설 이미지',
            photoMaterial: '사진 자료',
        },
        title: {
            listen: '소리 듣기',
            fold: '글감 접기',
            close: '닫기',
        },
    },

    // 단위
    units: {
        minute: '분',
        second: '초',
        page: 'p',
        count: '개',
        person: '명',
        person2: '인',
        times: '회',
        level: '레벨',
        chapter: '차시',
        etc: '외',
        vote: '표',
        notProvided: '미제공',
        score: '점',
    },
    // teacher 컴포넌트를 끌어쓰는 경우
    common: {
        button: {
            cancel: '취소',
            confirm: '확인',
        },
    },
};
